export default "__VITE_ASSET__Doi3w$cv__"